import { useState } from 'react';
import { MoveFocusInside } from 'react-focus-on';
import { useModalContentManager } from '@provider/notifier';
import { EditInput, Button, FloppyIcon, ShareIcon } from '@ui/kit';
import { modal, heading, input, legalText, text, buttonsWrapper } from './_shared.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const createRevisionModalConfig = {
  theme: "dialog",
  className: modal,
  content: /*#__PURE__*/jsx(CreateRevisionModal, {})
};
function CreateRevisionModal() {
  const manager = useModalContentManager();
  const [title, setTitle] = useState("");
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx("h1", {
      className: heading,
      children: "Gem din version af forl\xF8bet"
    }), /*#__PURE__*/jsx(MoveFocusInside, {
      children: /*#__PURE__*/jsx(EditInput, {
        className: input,
        mode: "always-visible",
        type: "text",
        "aria-label": "Titel p\xE5 din version",
        placeholder: "Angiv titel her*",
        value: title,
        onChange: setTitle
      })
    }), /*#__PURE__*/jsx("p", {
      className: legalText,
      children: "*V\xE6r opm\xE6rksom p\xE5 at navngivningen er synlig for alle med linket. Der m\xE5 derfor ikke v\xE6re f\xF8lsomme eller fortrolige oplysninger i navngivningen."
    }), /*#__PURE__*/jsx("p", {
      className: text,
      children: "Du kan tilg\xE5 din version af forl\xF8bet her i venstremenuen eller fra forl\xF8bets forside."
    }), /*#__PURE__*/jsx("p", {
      className: text,
      children: "Du kan altid tilpasse eller slette din version."
    }), /*#__PURE__*/jsxs("div", {
      className: buttonsWrapper,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "secondary",
        icon: /*#__PURE__*/jsx(FloppyIcon, {}),
        onClick: () => manager.onDismiss({
          title,
          intent: "save"
        }),
        disabled: !title,
        tooltip: {
          disabled: !!title,
          body: "Du skal angive en titel før du kan gemme din version",
          ariaType: "description"
        },
        children: "Gem og luk"
      }), /*#__PURE__*/jsx(Button, {
        theme: "primary",
        icon: /*#__PURE__*/jsx(ShareIcon, {}),
        disabled: !title,
        onClick: () => manager.onDismiss({
          title,
          intent: "save-and-share"
        }),
        tooltip: {
          disabled: !!title,
          body: "Du skal angive en titel før du kan gemme og dele din version",
          ariaType: "description"
        },
        children: "Gem og del"
      })]
    })]
  });
}

export { createRevisionModalConfig };
//# sourceMappingURL=create.js.map
